import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() color: string = ''
}
